<script>
  import alias from "../Stores/alias"
  import QRCode from "qrcode"
  import ShareComponent from "../../../../Shared/shareComponent.svelte"
  import { onMount } from "svelte"
  import notify from "../../../../Script/notify"

  /**
   * @type {String} - this contrains the src value for qrcode
   */
  let qrImage

  onMount(async () => {
    try {
      qrImage = await QRCode.toDataURL(`${$alias.proposedURL}`)
    } catch (error) {
      const info = "PAGE: Secure Access - Trust URL\nEVENT: While generating QRCode image using alias url."
      notify.danger(error, info)
    }
  })
</script>

<div class="rounded-md p-6 mobile:px-12 mobile:pt-12">
  <h1 class=" select-none text-2xl font-extrabold dark:text-white">Trust URL</h1>
  <div class="flex flex-col items-center justify-between gap-3 pt-3 sm:flex-row">
    <div class="order-2 flex w-full flex-col items-center gap-3 sm:order-1 sm:items-start md:w-4/6">
      <div class="pt-3">
        <a class="flex break-all text-center text-blue-500 underline hover:text-blue-600 active:text-blue-400 sm:text-start" target="_blank" href={$alias.proposedURL}>{$alias.proposedURL}</a>
        <p class="select-none text-center text-gray-200 sm:text-start">Click URL to open in new tab</p>
      </div>
      <!-- share -->
      <ShareComponent Link={$alias.proposedURL} />
    </div>
    <div class="order-1 flex w-full select-none flex-col items-center gap-3 sm:order-2 md:w-2/6">
      <img src={qrImage} class="w-1/3 rounded-md sm:w-4/6" alt="qrcode" />
      <!-- border-2 border-[#a0a1a580]  -->
    </div>
  </div>
</div>
